import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function PeruBosqueHumedo2025Layer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="0,1,2,3,4,5"
      styles=""
      format="image/png"
      version="1.1.1"
      transparent
      url="https://gis.bosques.gob.pe/server/services/Interoperabilidad/bosque_humedo_2025/MapServer/WMSServer"
      opacity={opacity}
    />
  )
}

export default PeruBosqueHumedo2025Layer
